import React from "react";
import styled from "styled-components";
import { Card, InputSelect, Text, InputDateRange } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import costsActionCreators from "~/store/costs/actions";
import costSelectors from "~/store/costs/selectors";
import lists from "~/lib/lists";
import InputMemberSelect from "~/components/InputMemberSelect";
const Wrapper = styled.aside`
  display: flex;
  flex-direction: column;
  position: relative;
`;
const CostSideBar = () => {
  const {
    t
  } = useTranslation();
  const filter = useSelector(costSelectors.getFilter);
  const startDate = useSelector(costSelectors.getFrom);
  const endDate = useSelector(costSelectors.getTo);
  const aggregatedBy = useSelector(costSelectors.getAggregatedBy);
  const dispatch = useDispatch();
  const handleFilter = newFilter => {
    dispatch(costsActionCreators.filtered({
      ...filter,
      ...newFilter
    }));
  };
  const handleAggregation = aggregateBy => {
    dispatch(costsActionCreators.aggregate(aggregateBy));
  };
  const handleDateSelect = (start, end) => {
    dispatch(costsActionCreators.setFrom(start));
    dispatch(costsActionCreators.setTo(end));
  };
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Card, {
    title: /*#__PURE__*/React.createElement(Text, {
      element: "h3"
    }, "Time"),
    s: {
      p: 0,
      mb: 3
    }
  }, /*#__PURE__*/React.createElement(InputDateRange, {
    initialStartDate: startDate,
    initialEndDate: endDate,
    label: t("CostSideBar.dateRange"),
    onChange: handleDateSelect,
    s: {
      mb: 5
    }
  }), /*#__PURE__*/React.createElement(InputSelect, {
    value: aggregatedBy,
    onChange: val => handleAggregation(val),
    name: "aggregatedBy",
    label: "Granularity",
    options: lists.costs.aggregatedBy.names,
    s: {
      mb: 5
    }
  }), /*#__PURE__*/React.createElement(Card, {
    title: /*#__PURE__*/React.createElement(Text, {
      element: "h3"
    }, "Filters"),
    s: {
      p: 0
    }
  }, /*#__PURE__*/React.createElement(InputSelect, {
    value: filter?.types || "",
    label: "Types",
    placeholder: "Choose types",
    options: Object.keys(lists.costs.types.names).map(key => ({
      id: key,
      value: lists.costs.types.names[key],
      tip: lists.costs.types.descriptions[key]
    })),
    onChange: value => handleFilter({
      ...filter,
      types: value
    }),
    multiple: true,
    fullSelections: true,
    s: {
      mb: 5
    }
  }), /*#__PURE__*/React.createElement(InputSelect, {
    value: filter?.subtypes || "",
    label: "Subtypes",
    placeholder: "Choose subtypes",
    options: lists.costs.subtypes.names,
    onChange: value => handleFilter({
      ...filter,
      subtypes: value
    }),
    multiple: true,
    fullSelections: true,
    s: {
      mb: 5
    }
  }), /*#__PURE__*/React.createElement(InputMemberSelect, {
    value: filter?.memberIds || "",
    label: "Members",
    placeholder: "Choose members",
    onChange: value => handleFilter({
      ...filter,
      memberIds: value
    }),
    multiple: true,
    fullSelections: true,
    s: {
      mb: 5
    }
  }), /*#__PURE__*/React.createElement(InputSelect, {
    value: filter?.sources || "",
    label: "Sources",
    placeholder: "Choose sources",
    options: lists.topics.footprintSources.names,
    onChange: value => handleFilter({
      ...filter,
      sources: value
    }),
    multiple: true,
    fullSelections: true,
    s: {
      mb: 5
    }
  }))));
};
export default CostSideBar;